export function noop() { }
export function animationFrame() {
    return new Promise((res) => requestAnimationFrame(() => res()));
}
export function sleep(ms) {
    return new Promise((res) => setTimeout(() => res(), ms));
}
export function dispatchCustomEvent(element, eventName) {
    element.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true,
    }));
}
